import { usePadraoSelecionado } from './padrao'

/**
 * Seletor global de padrão — cabeçalho de `3a`, `3b` e `3c`.
 *
 * `<select>` nativo alimentado por `GET /compliance/padroes` (BR-24: catálogo,
 * nunca texto livre).
 */
export function SeletorDePadrao() {
  const { consulta, padroes, padrao, selecionar } = usePadraoSelecionado()

  return (
    <label className="rounded-control border-navy-100 bg-navy-50 text-iox-navy inline-flex items-center gap-2 border px-4 py-1.5 type-label">
      <i className="ph ph-calendar-check" aria-hidden="true" />
      <span aria-hidden="true">Padrão</span>
      <select
        aria-label="Padrão"
        className="text-iox-navy bg-transparent type-label font-semibold"
        value={padrao?.id ?? ''}
        disabled={consulta.isPending || padroes.length === 0}
        onChange={(e) => selecionar(e.target.value)}
      >
        {padroes.length === 0 && <option value="">{consulta.isPending ? 'carregando…' : 'nenhum padrão'}</option>}
        {padroes.map((p) => (
          <option key={p.id} value={p.id}>
            {p.nome}
            {p.status === 'rascunho' ? ' (rascunho)' : ''}
          </option>
        ))}
      </select>
    </label>
  )
}
